export { getUserInfoServerAction } from 'next-flight-server-reference-proxy-loader?id=7fb21ca0e4e3c8235dbaafe3dc752f68b834a64421&name=getUserInfoServerAction!'